import { createSlice } from '@reduxjs/toolkit'

export const isCustomSlice = createSlice({
    name: 'isCustom',
    initialState: {
        value: false,
    },
    reducers: {
        setIsCustom: (state, action) => {
            state.value = action.payload;
        }
    },
})

export const { setIsCustom } = isCustomSlice.actions

export default isCustomSlice.reducer
